
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|286|6224|9992)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
